module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chatContextMenu"
    },
    on: {
      "click": _vm.preventEvent
    }
  }, [_c('div', {
    attrs: {
      "id": "chatClickedUser"
    }
  }), _vm._v(" "), _vm._l(((_vm.isAdmin ? _vm.adminMenuList : _vm.menuList)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "chatContextMenuItem",
      class: item.class === 'noContents' ? 'noContents' : '',
      on: {
        "click": function($event) {
          item.link === null ? 'javascript:;' : item.link(this, item.functionIndex)
        }
      }
    }, [(item.class !== 'noContents') ? _c('span', {
      staticClass: "chatContextMenuIcon",
      class: item.class
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "chatContextMenuText",
      class: item.class.indexOf('dangerousButton') >= 0 ? 'dangerousButton' : ''
    }, [_vm._v(_vm._s(item.name))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ac7b0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-contextMenu.vue
// module id = 101
// module chunks = 0